export const ProgressBar = ({ progressPercentage }) => {
    return (
        <div className="space-y-2">
            <div className="text-[12px] font-semibold text-[#6B7280]">
                {Math.ceil(progressPercentage)}%
            </div>
            <div className="h-[8px] w-full overflow-hidden rounded-full bg-[#EFE9E0]">
                <div
                    style={{ width: `${progressPercentage}%` }}
                    className={`h-full rounded-full transition-[width] duration-200 ${
                        progressPercentage < 70 ? 'bg-primary' : 'bg-green-600'
                    }`}></div>
            </div>
        </div>
    )
}
